import { webApiService } from '@/services'
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { MdQrCode2 } from 'react-icons/md'

interface IOwnProps {
  isOpen: boolean
  onClose: () => void
  id: number
  initialSeal: string
  initialSeal2: string
  initialSeal3: string
  onUpdated?: (id: number, seal: string, seal2: string, seal3: string) => void
  reloadAction?: () => void | Promise<void>
}

const ModalSellos: React.FC<IOwnProps> = ({ isOpen, onClose, id, initialSeal, initialSeal2, initialSeal3, onUpdated, reloadAction }) => {
  const [seal, setSeal] = useState(initialSeal ?? '')
  const [seal2, setSeal2] = useState(initialSeal2 ?? '')
  const [seal3, setSeal3] = useState(initialSeal3 ?? '')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setSeal(initialSeal ?? '')
      setSeal2(initialSeal2 ?? '')
      setSeal3(initialSeal3 ?? '')
    }
  }, [isOpen, initialSeal, initialSeal2, initialSeal3])

  const onSave = () => {
    setLoading(true)
    webApiService.updateOnlySeals({ idTradein: id, seal, seal2, seal3 }).then(() => {
      enqueueSnackbar('Sellos actualizados correctamente', { variant: 'success' })
      onUpdated && onUpdated(id, seal, seal2, seal3)
      reloadAction && reloadAction()
      setLoading(false)
      onClose()
    }).catch((error) => {
      if (error.response !== undefined && error.response.data !== undefined) {
        enqueueSnackbar(error.response.data.message ?? 'Error al actualizar los sellos', { variant: 'error' })
      } else {
        enqueueSnackbar('Error al actualizar los sellos', { variant: 'error' })
      }
      setLoading(false)
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} placement='top-center' backdrop='blur'>
      <ModalContent>
        {(close) => (
          <>
            <ModalHeader className='flex flex-col gap-1'>Editar sellos</ModalHeader>
            <ModalBody>
              <p className='text-sm text-default-600'>
                Se actualizarán los sellos del tradein <span className='font-bold'>#{id}</span>.
              </p>
              <Input
                autoFocus
                value={seal}
                endContent={<MdQrCode2 className='text-2xl text-default-400 pointer-events-none flex-shrink-0' />}
                label='Sello'
                onChange={(e) => setSeal(e.target.value)}
                placeholder='Ingrese sello'
                variant='bordered'
              />
              <Input
                value={seal2}
                endContent={<MdQrCode2 className='text-2xl text-default-400 pointer-events-none flex-shrink-0' />}
                label='Sello 2'
                onChange={(e) => setSeal2(e.target.value)}
                placeholder='Ingrese sello 2'
                variant='bordered'
              />
              <Input
                value={seal3}
                endContent={<MdQrCode2 className='text-2xl text-default-400 pointer-events-none flex-shrink-0' />}
                label='Sello 3 (opcional)'
                onChange={(e) => setSeal3(e.target.value)}
                placeholder='Ingrese sello 3'
                variant='bordered'
              />
            </ModalBody>
            <ModalFooter>
              <Button color='danger' variant='flat' onPress={close}>Cancelar</Button>
              <Button color='primary' onPress={onSave} isLoading={loading}>Guardar</Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default ModalSellos
